import { render } from "./JointCommitteeEmailCompose.vue?vue&type=template&id=399aa9f1&scoped=true"
import script from "./JointCommitteeEmailCompose.vue?vue&type=script&lang=js"
export * from "./JointCommitteeEmailCompose.vue?vue&type=script&lang=js"

import "./JointCommitteeEmailCompose.vue?vue&type=style&index=0&id=399aa9f1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-399aa9f1"

export default script